import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[asset-tracking-tabs-host]',
})
export class AssetTrackingTabsDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
